export class ValidationRules {
  public required: ValidationRule = value => !!value || 'Required.';

  public titleLength: ValidationRule = value =>
    (value && value.length <= 100) || 'Maximum of 100 characters.';

  public socialBodyLength: ValidationRule = value =>
    (value && value.length <= 2000) || 'Maximum of 2000 characters.';
}
